/***
*
*   APP NAV
*   Primary navigation used inside the main app component
*
*   PROPS
*   type: fixed or popup (style of nav on mobile)
*   items: array of objects containing label, link and icon (optional)
*
**********/

import { useState, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { Icon, AuthContext, Logo, Animate, ViewContext, useTranslation } from 'components/lib';
import './app.scss';


export function AppNav(props) {

	// state
	// eslint-disable-next-line
	const [open, setOpen] = useState(false); // mobile is open
	const [expanded, setExpanded] = useState(false); // desktop is expanded
	const context = useContext(AuthContext);
	const viewContent = useContext(ViewContext)

	const { t } = useTranslation();

	const showExpiredWarning = (addon) => {
		viewContent.notification.show(t('nav.addonExpire', { addon: addon }), "warning")
	}

	return (
		<nav className={`sidebar popup ${open && 'open'} ${expanded && 'expanded'}`}
			onMouseEnter={e => setExpanded(true)}
			onMouseLeave={e => setExpanded(false)}>

			{/* <Button
        icon={ open ? 'x' : 'menu' }
        color={ 'dark' }
        size={ 12 }
        className='btn-togglenav'
        action={ e => setOpen(!open) }
      /> */}

			{expanded &&
				<Animate
					type='pop'
				>
					<span className={'logoStyle'}>
						<Logo
							color="short"
							path={context.user.plan === "enterprise" ? '/enterprise' : '/scholar'}
						/>
					</span>
				</Animate>
			}
			<section className='nav-links'>
				{props.items?.map(item => {

					if (item.link) {
						return (
							<NavLink
								key={item.label}
								to={item.link}
								style={{
									width: (100 / props.items.length) + '%',
									...(item.style ? item.style : {})
								}}
								onClick={(e) => {
									if (item?.showWarning) {
										e.preventDefault()
										showExpiredWarning(item.label)
									}
								}}
							>

								{item.icon &&
									<Icon
										className='icon'
										image={item.icon}
										size={open ? 15 : 18}
										// color={open ? 'dark' : 'light'}
										color={item?.style?.color ? item.style.color : '#000000'}
									/>
								}
								{item.label &&
									<span className='label'
										style={{
											color: item?.style?.color ? item.style.color : '#000000'
										}}
									>
										{item.label}
									</span>
								}

							</NavLink>
						);
					}

					return (
						<div key={item.label} onClick={item.action}>

							{item.icon &&
								<Icon
									className='icon'
									image={item.icon}
									size={open ? 15 : 18}
									color='#000000'
								// color={open ? 'dark' : 'light'}
								/>
							}
							{item.label &&
								<span className='label'>
									{item.label}
								</span>
							}
						</div>
					)
				})}
			</section>
		</nav>
	);
}
